module.exports = __webpack_public_path__ + "img/p2.7b7fc19c.png";